// extracted by mini-css-extract-plugin
export default {"button-container":"UserEditForm_button-container__wRiaJ","button":"UserEditForm_button__9QWyQ","cancel":"UserEditForm_cancel__Vfl-m","add":"UserEditForm_add__IKVQN"};